"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Interactable {
    static isInteractable(object) {
        if (object == null)
            return false;
        const myInterface = object;
        return myInterface.inPerimeter !== undefined;
    }
}
exports.Interactable = Interactable;
